import type { Jsonable } from '@orus.eu/error'
import { type QuoteModelInput, type QuoteModelOutputModel, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import { type Quote, quoteV2ToSerializedQuoteData } from '@orus.eu/quote'

import { AbstractDimension } from './abstract-dimension.ts'

export class ProductQuoteV2Dimension<
  NAME extends string,
  QUOTE extends Quote<Jsonable, string | void, string, string, string, string | void>,
> extends AbstractDimension<NAME, QUOTE> {
  override formatToString(value: QUOTE): string {
    return quoteV2ToSerializedQuoteData(value)
  }
}

export class ProductQuoteV3Dimension<
  NAME extends string,
  Key extends keyof QuoteModelInput = keyof QuoteModelInput,
  Model extends QuoteModelInput = QuoteModelInput,
  QUOTE extends QuoteModelOutputModel<Key, Model> = QuoteModelOutputModel<Key, Model>,
> extends AbstractDimension<NAME, QUOTE> {
  override formatToString(value: QUOTE): string {
    return quoteV3ToSerializedQuoteData(value)
  }
}
